import { Flex, Group, Icon, notification, PopOver, Text } from "components/common"
import { Space } from "antd"
import { localisedValue } from "utils"
import dayjs from "dayjs"
import { DateFormat } from "components/common"
import { useLazyGetFlaggedLeadDetailsQuery } from "features/shared/api"
import { useState, useMemo, useEffect } from "react"
import { t } from "i18next"
import theme from "utils/themeVars"
import { CLIENT_DETAIL_PATH } from "constants/app-paths"
import { Link } from "react-router-dom"
import { useGetLeadCategoriesQuery } from "../../../clients/detail/api"

const showRedirectIcon = {
  flagged_in_audit_review: true,
  flagged_in_lead_review: true,
}
const FlaggedLeads = ({ lead, redirectToClientReviews = false }) => {
  const { data: leadCategoriesData } = useGetLeadCategoriesQuery({ flagVisibility: true })
  const [fetchFlaggedLeadDetails, { data: flaggedLeadData, isFetching: isFetchingFlaggedLead }] =
    useLazyGetFlaggedLeadDetailsQuery()

  const [activeFlagId, setActiveFlagId] = useState(null)
  const [visibleFlags, setVisibleFlags] = useState([])

  useEffect(() => {
    if (lead?.flagIds && leadCategoriesData?.flagColorIdMap) {
      const filteredFlags = lead.flagIds.filter(id => id in leadCategoriesData.flagColorIdMap)
      setVisibleFlags(filteredFlags)
    }
  }, [lead?.flagIds, leadCategoriesData?.flagColorIdMap])

  const getContentForFlaggedLead = (flaggedLeadData, lead, redirectToClientReviews) => {
    return (
      flaggedLeadData && (
        <Group gap="8px" template="initial">
          <Flex gap="6px" align="center" justify="space-between">
            <Space gap="6px" align="center">
              <Icon icon="IoFlag" size="14px" color={flaggedLeadData?.flagColor} />
              <strong>{localisedValue({ object: flaggedLeadData?.InternalInquiryCategory, key: "title" })}</strong>
            </Space>
            {redirectToClientReviews && showRedirectIcon[flaggedLeadData?.InternalInquiryCategory?.key] && (
              <Link to={CLIENT_DETAIL_PATH.replace(":clientId", lead?.clientId) + `?activeTab=leadReviews`}>
                <Icon icon="HiArrowRight" size="16px" color={theme["primary-color"]} />
              </Link>
            )}
          </Flex>

          <div className="fs12">
            {localisedValue({ object: flaggedLeadData?.InternalInquiryCategory, key: "description" })}{" "}
          </div>

          <div>
            <Flex align="baseline">
              <Text className="fs12" style={{ color: theme["gray600"] }}>
                {t("Added Date")}:
              </Text>
              <DateFormat
                dateClassName="fs12"
                date={dayjs(flaggedLeadData?.createdAt)}
                showTime
                icon=""
                showTimeWithTooltip={false}
                color={theme["gray900"]}
                dateColor={theme["gray900"]}
              />
            </Flex>
            <div>
              <Text className="fs12" style={{ color: theme["gray600"] }}>
                {t("Added By")}:
              </Text>
              <Text className="fs12" style={{ color: theme["gray900"], marginLeft: 4 }}>
                {localisedValue({ object: flaggedLeadData?.User, key: "name" })}
              </Text>
            </div>
          </div>
        </Group>
      )
    )
  }

  const onFlagClick = (e, flag) => {
    e.stopPropagation()
    setActiveFlagId(flag)
    fetchFlaggedLeadDetails({ inquiryId: lead?.id, categoryId: flag }, true)
      .unwrap()
      .then(responseData => {
        if (responseData) {
          setActiveFlagId(flag)
        } else {
          setActiveFlagId(flag)
        }
      })
      .catch(e => {
        notification?.error({ message: e?.message })
        setActiveFlagId(null)
      })
  }
  return (
    <>
      {visibleFlags?.map(flag => (
        <PopOver
          trigger="click"
          visible={activeFlagId === flag && !isFetchingFlaggedLead}
          onVisibleChange={visible => {
            if (!visible) setActiveFlagId(null)
          }}
          content={getContentForFlaggedLead(flaggedLeadData, lead, redirectToClientReviews)}
          overlayInnerStyle={{ width: 350 }}
        >
          <Icon
            hasBackground
            icon="IoFlag"
            color={leadCategoriesData?.flagColorIdMap?.[flag]}
            size="18px"
            style={{ padding: 3 }}
            iconContainerStyle={{ translate: "0px 2px", padding: 0 }}
            className="pointer"
            isLoading={activeFlagId === flag && isFetchingFlaggedLead}
            onClick={e => onFlagClick(e, flag)}
          />
        </PopOver>
      ))}
    </>
  )
}
export default FlaggedLeads
